import React from "react";
import { Box, Divider, Flex, Text } from "@chakra-ui/react";
import HelpTooltip from "@/shared/components/help-tooltip";
import { Trans } from "react-i18next";

export interface SummaryItem {
  title: string;
  value: string;
  tooltipContent?: string;
  textColor?: string;
  textStyle?: string;
  backgroundColor?: string;
}

interface Props {
  summaryList: SummaryItem[];
}

function SummaryCardList({ summaryList }: Props) {
  return (
    <Flex
      borderRadius={"8px"}
      background={"#F7F9FA"}
      alignItems={"center"}
      overflow={"hidden"}
      minHeight={"70px"}
    >
      {summaryList.map((item, index) => (
        <React.Fragment key={item.title + index}>
          {index > 0 && (
            <Divider
              orientation="vertical"
              color={"#D4D4D1"}
              height={"40px"}
              opacity={1}
            />
          )}
          <SummaryCard summaryItem={item} />
        </React.Fragment>
      ))}
    </Flex>
  );
}

export default SummaryCardList;

interface SummaryCardProps {
  summaryItem: SummaryItem;
}

const SummaryCard = ({ summaryItem }: SummaryCardProps) => {
  const {
    title,
    value,
    tooltipContent,
    textColor,
    backgroundColor,
    textStyle,
  } = summaryItem;

  return (
    <Flex
      flex={1}
      padding={"12px 16px"}
      flexDirection={"column"}
      gap={"2px"}
      background={backgroundColor ?? "inherit"}
    >
      <Flex alignItems={"center"} gap={"2px"}>
        <Text textStyle={"body-sm-medium"} color={"#6F6F6C"}>
          {title}
        </Text>
        {tooltipContent && (
          <Box paddingTop={"1px"}>
            <HelpTooltip
              text={
                <Trans
                  i18nKey={tooltipContent}
                  components={{
                    br: <br />,
                  }}
                />
              }
              minWidth={"fit-content"}
            />
          </Box>
        )}
      </Flex>
      <Text
        textStyle={textStyle ?? "body-lg-bold"}
        color={textColor ?? "#444444"}
      >
        {value}
      </Text>
    </Flex>
  );
};
